import styled from 'styled-components';

export const AverageContainer = styled.div`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

export const AverageTitle = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.xl};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const AverageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const AverageSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const AverageInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const AverageLabel = styled.span`
  font-size: 16px;
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.secondary};
  white-space: nowrap;
`;

export const AverageValue = styled.div<{ $isSmallFontSize?: boolean }>`
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
  font-size: ${({ $isSmallFontSize, theme }) => ($isSmallFontSize ? theme.typography.fontSize.xl : theme.typography.fontSize.xxl)};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text.primary};
  line-height: 1;
`;

export const AverageUnit = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  color: #666;
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
`;

export const AverageIcon = styled.span`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`;

